module.exports = __webpack_public_path__ + "img/ENlogo@2x.d87024dc.png";